export const riskProfileQuestions = [
  {
    id: 'q1',
    question: 'Current age (years):',
    options: [
      { value: 'a', label: '<40', score: 4 },
      { value: 'b', label: '41-50', score: 3 },
      { value: 'c', label: '51-65', score: 2 },
      { value: 'd', label: '>65', score: 1 }
    ]
  },
  {
    id: 'q2',
    question: 'Net worth (INR crores):',
    options: [
      { value: 'a', label: '<50', score: 1 },
      { value: 'b', label: '50-100', score: 2 },
      { value: 'c', label: '100-500', score: 3 },
      { value: 'd', label: '>500', score: 4 }
    ]
  },
  {
    id: 'q3',
    question: 'Investments excluding residential real estate (INR crores):',
    options: [
      { value: 'a', label: '<25', score: 1 },
      { value: 'b', label: '25-100', score: 2 },
      { value: 'c', label: '100-500', score: 3 },
      { value: 'd', label: '>500', score: 4 }
    ]
  },
  {
    id: 'q4',
    question: 'Assets in income generating investments (deposits, bonds, debt mutual funds, rental etc.):',
    options: [
      { value: 'a', label: '<25%', score: 4 },
      { value: 'b', label: '25-50%', score: 3 },
      { value: 'c', label: '50-75%', score: 2 },
      { value: 'd', label: '>75%', score: 1 }
    ]
  },
  {
    id: 'q5',
    question: 'How familiar are you with the world of investments?',
    options: [
      { value: 'a', label: 'I am not aware of the recent developments', score: 1 },
      { value: 'b', label: "I know what's trending in the financial markets, but I cannot use it to manage my investments portfolio", score: 2 },
      { value: 'c', label: 'I have adequate information on financial markets and its impact on my portfolio', score: 3 }
    ]
  },
  {
    id: 'q6',
    question: 'How many years of experience do you have in managing your investment portfolio?',
    options: [
      { value: 'a', label: '<10 years', score: 1 },
      { value: 'b', label: '10-20 years', score: 2 },
      { value: 'c', label: '>20 years', score: 3 }
    ]
  },
  {
    id: 'q7',
    question: 'As an individual, which recreation or sport do/did you most relate with?',
    options: [
      { value: 'a', label: 'Mountaineering, skydiving, car racing', score: 3 },
      { value: 'b', label: 'Golf, swimming, archery', score: 2 },
      { value: 'c', label: 'Football, cycling, running', score: 1 }
    ]
  },
  {
    id: 'q8',
    question: 'How stable is your current (and future) source of income such as business income, salary, fixed returns assets, dividends etc.?',
    options: [
      { value: 'a', label: 'Unpredictable', score: 1 },
      { value: 'b', label: 'Somewhat stable', score: 2 },
      { value: 'c', label: 'Very stable', score: 3 }
    ]
  },
  {
    id: 'q9',
    question: 'What are you seeking from your investments?',
    options: [
      { value: 'a', label: 'Mostly income', score: 1 },
      { value: 'b', label: 'Blend of income and capital appreciation', score: 2 },
      { value: 'c', label: 'Mostly capital appreciation', score: 3 }
    ]
  },
  {
    id: 'q10',
    question: 'Do you need to draw from your investment portfolio to meet expenses in the next 3 years?',
    options: [
      { value: 'a', label: 'No', score: 3 },
      { value: 'b', label: 'Yes, up to 10%', score: 2 },
      { value: 'c', label: 'Yes, up to 25%', score: 1 }
    ]
  },
  {
    id: 'q11',
    question: 'Can investments in fixed income-oriented products return negative in a year?',
    options: [
      { value: 'a', label: 'No, they are fixed income and quite stable', score: 1 },
      { value: 'b', label: 'Yes, if interest rates rise significantly', score: 2 }
    ]
  },
  {
    id: 'q12',
    question: 'In the last 15 years, there have been multiple times that Indian equities have corrected by more than 25%. This means all your equity holdings could have potentially been in the red up to or more than 25%. If you see or are advised on a major correction coming, you would...',
    options: [
      { value: 'a', label: 'Sell all equity investments', score: 1 },
      { value: 'b', label: 'Sell some of the equity investments', score: 2 },
      { value: 'c', label: 'Hold on', score: 3 },
      { value: 'd', label: "Buy more if there's available surplus", score: 4 }
    ]
  },
  {
    id: 'q13',
    question: 'Investment products can have a poor run with negative returns and/or lag the benchmark. Upon such observation, how long would you hold the product before deciding to sell?',
    options: [
      { value: 'a', label: '<1 year', score: 1 },
      { value: 'b', label: '1-3 years', score: 2 },
      { value: 'c', label: '>3 years', score: 3 }
    ]
  },
  {
    id: 'q14',
    question: 'Between higher degree of safety and higher returns, would you choose safety even if you were told that the returns may not beat inflation, hence reducing your purchasing power?',
    options: [
      { value: 'a', label: 'Yes, safety is paramount', score: 1 },
      { value: 'b', label: 'I can trade some amount of safety to ensure my investments beat inflation', score: 2 },
      { value: 'c', label: "No, I will seek higher returns if 'safe' products do not even beat inflation", score: 3 }
    ]
  },
  {
    id: 'q15',
    question: 'Would you tolerate capital loss in the short-term (say 1-2 years) if there is potential of a strong upside over the longer term?',
    options: [
      { value: 'a', label: 'No', score: 1 },
      { value: 'b', label: 'Cannot say, depends on the quantum of loss', score: 2 },
      { value: 'c', label: 'Yes', score: 3 }
    ]
  },
  {
    id: 'q16',
    question: 'What is your concept of long-term with respect to your portfolio?',
    options: [
      { value: 'a', label: '1-3 years', score: 1 },
      { value: 'b', label: '3-10 years', score: 2 },
      { value: 'c', label: '>10 years', score: 3 }
    ]
  }
];

export const investmentMandateQuestions = [
  {
    id: 'im1',
    question: 'Investment Horizon:',
    type: 'select',
    options: [
      { value: 'short', label: 'Short term (0-3 years)' },
      { value: 'medium', label: 'Medium-term (3-5 years)' },
      { value: 'long', label: 'Long term (5-7 years)' },
      { value: 'other', label: 'Others - Please specify' }
    ]
  }
];

export const calculateRiskProfile = (answers) => {
  const totalScore = Object.values(answers).reduce((sum, answer) => {
    const question = riskProfileQuestions.find(q => q.id === answer.questionId);
    if (!question) return sum;
    const option = question.options.find(opt => opt.value === answer.value);
    return sum + (option?.score || 0);
  }, 0);

  // Score ranges for risk profiles
  if (totalScore <= 24) {
    return { profile: 'Conservative', score: totalScore };
  } else if (totalScore <= 36) {
    return { profile: 'Moderate', score: totalScore };
  } else if (totalScore <= 48) {
    return { profile: 'Growth', score: totalScore };
  } else {
    return { profile: 'Aggressive', score: totalScore };
  }
};
